require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es7.object.entries");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.string.small");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

!function (n, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports, require("styled-components"), require("react"), require("react-dismissible"), require("react-color"), require("color-string"), require("@tinacms/react-forms"), require("react-dropzone"), require("@tinacms/styles"), require("@tinacms/icons"), require("@tinacms/form-builder"), require("react-beautiful-dnd"), require("@tinacms/react-core")) : "function" == typeof define && define.amd ? define(["exports", "styled-components", "react", "react-dismissible", "react-color", "color-string", "@tinacms/react-forms", "react-dropzone", "@tinacms/styles", "@tinacms/icons", "@tinacms/form-builder", "react-beautiful-dnd", "@tinacms/react-core"], e) : e((n = n || self)["@tinacms/fields"] = {}, n.styled, n.React, n.reactDismissible, n.reactColor, n.colorString, n.reactForms, n.reactDropzone, n.styles, n.icons, n.formBuilder, n.reactBeautifulDnd, n.reactCore);
}(this, function (n, e, k, C, t, r, z, d, p, u, c, g, m) {
  "use strict";

  var a = "default" in e ? e["default"] : e,
      _I = function I() {
    return (_I = Object.assign || function (n) {
      for (var e, t = 1, r = arguments.length; t < r; t++) {
        for (var a in e = arguments[t]) {
          Object.prototype.hasOwnProperty.call(e, a) && (n[a] = e[a]);
        }
      }

      return n;
    }).apply(this, arguments);
  };

  function f(n, e) {
    var t = {};

    for (var r in n) {
      Object.prototype.hasOwnProperty.call(n, r) && e.indexOf(r) < 0 && (t[r] = n[r]);
    }

    if (null != n && "function" == typeof Object.getOwnPropertySymbols) {
      var a = 0;

      for (r = Object.getOwnPropertySymbols(n); a < r.length; a++) {
        e.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(n, r[a]) && (t[r[a]] = n[r[a]]);
      }
    }

    return t;
  }

  function v(i, o, l, s) {
    return new (l = l || Promise)(function (n, e) {
      function t(n) {
        try {
          a(s.next(n));
        } catch (n) {
          e(n);
        }
      }

      function r(n) {
        try {
          a(s["throw"](n));
        } catch (n) {
          e(n);
        }
      }

      function a(e) {
        e.done ? n(e.value) : new l(function (n) {
          n(e.value);
        }).then(t, r);
      }

      a((s = s.apply(i, o || [])).next());
    });
  }

  function h(t, r) {
    var a,
        i,
        o,
        n,
        l = {
      label: 0,
      sent: function sent() {
        if (1 & o[0]) throw o[1];
        return o[1];
      },
      trys: [],
      ops: []
    };
    return n = {
      next: e(0),
      "throw": e(1),
      "return": e(2)
    }, "function" == typeof Symbol && (n[Symbol.iterator] = function () {
      return this;
    }), n;

    function e(e) {
      return function (n) {
        return function (e) {
          if (a) throw new TypeError("Generator is already executing.");

          for (; l;) {
            try {
              if (a = 1, i && (o = 2 & e[0] ? i["return"] : e[0] ? i["throw"] || ((o = i["return"]) && o.call(i), 0) : i.next) && !(o = o.call(i, e[1])).done) return o;

              switch (i = 0, o && (e = [2 & e[0], o.value]), e[0]) {
                case 0:
                case 1:
                  o = e;
                  break;

                case 4:
                  return l.label++, {
                    value: e[1],
                    done: !1
                  };

                case 5:
                  l.label++, i = e[1], e = [0];
                  continue;

                case 7:
                  e = l.ops.pop(), l.trys.pop();
                  continue;

                default:
                  if (!(o = 0 < (o = l.trys).length && o[o.length - 1]) && (6 === e[0] || 2 === e[0])) {
                    l = 0;
                    continue;
                  }

                  if (3 === e[0] && (!o || e[1] > o[0] && e[1] < o[3])) {
                    l.label = e[1];
                    break;
                  }

                  if (6 === e[0] && l.label < o[1]) {
                    l.label = o[1], o = e;
                    break;
                  }

                  if (o && l.label < o[2]) {
                    l.label = o[2], l.ops.push(e);
                    break;
                  }

                  o[2] && l.ops.pop(), l.trys.pop();
                  continue;
              }

              e = r.call(t, l);
            } catch (n) {
              e = [6, n], i = 0;
            } finally {
              a = o = 0;
            }
          }

          if (5 & e[0]) throw e[1];
          return {
            value: e[0] ? e[1] : void 0,
            done: !0
          };
        }([e, n]);
      };
    }
  }

  function i(n, e) {
    return Object.defineProperty ? Object.defineProperty(n, "raw", {
      value: e
    }) : n.raw = e, n;
  }

  var o,
      l,
      s,
      x,
      b,
      y,
      F,
      w,
      E = e.css(l = l || i(["\n  padding: var(--tina-padding-small);\n  border-radius: var(--tina-radius-small);\n  background: var(--tina-color-grey-0);\n  font-size: var(--tina-font-size-2);\n  line-height: 1.35;\n  position: relative;\n  background-color: var(--tina-color-grey-0);\n  transition: all 85ms ease-out;\n  border: 1px solid var(--tina-color-grey-2);\n  width: 100%;\n  margin: 0;\n  outline: none;\n  box-shadow: 0 0 0 2px\n    ", ";\n\n  &:hover {\n    box-shadow: 0 0 0 2px var(--tina-color-grey-3);\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 2px\n      ", ";\n  }\n\n  &::placeholder {\n    font-size: var(--tina-font-size-2);\n    color: var(--tina-color-grey-3);\n  }\n\n  ", ";\n"], ["\n  padding: var(--tina-padding-small);\n  border-radius: var(--tina-radius-small);\n  background: var(--tina-color-grey-0);\n  font-size: var(--tina-font-size-2);\n  line-height: 1.35;\n  position: relative;\n  background-color: var(--tina-color-grey-0);\n  transition: all 85ms ease-out;\n  border: 1px solid var(--tina-color-grey-2);\n  width: 100%;\n  margin: 0;\n  outline: none;\n  box-shadow: 0 0 0 2px\n    ", ";\n\n  &:hover {\n    box-shadow: 0 0 0 2px var(--tina-color-grey-3);\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 2px\n      ", ";\n  }\n\n  &::placeholder {\n    font-size: var(--tina-font-size-2);\n    color: var(--tina-color-grey-3);\n  }\n\n  ", ";\n"]), function (n) {
    return n.error ? "var(--tina-color-error)" : "transparent";
  }, function (n) {
    return n.error ? "var(--tina-color-error)" : "var(--tina-color-primary)";
  }, function (n) {
    return n.small && e.css(o = o || i(["\n      font-size: var(--tina-font-size-1);\n      padding: 8px var(--tina-padding-small);\n    "], ["\n      font-size: var(--tina-font-size-1);\n      padding: 8px var(--tina-padding-small);\n    "]));
  }),
      B = a.input.withConfig({
    displayName: "Input",
    componentId: "sc-lg4wxu"
  })(s = s || i(["\n  ", "\n"], ["\n  ", "\n"]), E),
      N = a.input.withConfig({
    displayName: "BaseTextField",
    componentId: "sc-179abbl"
  })(x = x || i(["\n  ", "\n"], ["\n  ", "\n"]), E),
      D = a.textarea.withConfig({
    displayName: "TextArea",
    componentId: "sc-1gdbply"
  })(b = b || i(["\n  ", ";\n  resize: vertical;\n  height: 160px;\n"], ["\n  ", ";\n  resize: vertical;\n  height: 160px;\n"]), E);
  (w = F = F || {}).Hex = "hex", w.RGB = "rgb";

  function P(n) {
    if (!n) return null;
    var e = r.get(n);
    if (!e) return null;
    var t = e.value;
    return {
      r: t[0],
      g: t[1],
      b: t[2],
      a: t[3]
    };
  }

  function j(n) {
    function t() {
      c.current && u(c.current.getBoundingClientRect());
    }

    var e = n.colorFormat,
        r = n.userColors,
        a = void 0 === r ? nn : r,
        i = n.widget,
        o = void 0 === i ? "sketch" : i,
        l = n.input,
        s = z.useFormPortal(),
        c = k.useRef(null),
        d = k.useState(null),
        p = d[0],
        u = d[1],
        g = k.useState(!1),
        m = g[0],
        f = g[1];
    k.useEffect(function () {
      if (p) {
        var n = p.top + p.height / 2,
            e = window.innerHeight;
        f(e / 2 < n);
      }
    }, [p]), k.useEffect(function () {
      var n = !1;
      setTimeout(function () {
        t();
      }, 100);

      function e() {
        clearTimeout(n), n = setTimeout(t, 100);
      }

      return window.addEventListener("resize", e), function () {
        window.removeEventListener("resize", e);
      };
    }, [c.current]);
    var v = en[o];
    if (!v) throw new Error("You must specify a widget type.");

    function h() {
      var n = !b;
      y(n), n && t();
    }

    var x = k.useState(!1),
        b = x[0],
        y = x[1],
        w = (e || F.Hex).toLowerCase(),
        E = l.value ? U[w].parse(l.value) : null;
    return k.createElement(Z, {
      ref: c
    }, k.createElement(K, {
      onClick: h,
      colorRGBA: E,
      colorFormat: w
    }), b && k.createElement(s, null, k.createElement(Q, {
      openTop: m,
      triggerBoundingBox: p
    }, k.createElement(C.Dismissible, {
      click: !0,
      escape: !0,
      disabled: !b,
      onDismiss: h
    }, k.createElement(v, {
      presetColors: function () {
        for (var n = 0, e = 0, t = arguments.length; e < t; e++) {
          n += arguments[e].length;
        }

        var r = Array(n),
            a = 0;

        for (e = 0; e < t; e++) {
          for (var i = arguments[e], o = 0, l = i.length; o < l; o++, a++) {
            r[a] = i[o];
          }
        }

        return r;
      }(a, [$]),
      color: E || {
        r: 0,
        g: 0,
        b: 0,
        a: 0
      },
      onChange: function onChange(n) {
        var e = n.hex === $ ? null : _I(_I({}, n.rgb), {
          a: 1
        });
        l.onChange(e ? U[w].getValue(e) : null);
      },
      disableAlpha: !0,
      width: "240px"
    })))));
  }

  function S(n) {
    var e = !(!n.input.value && !n.input.checked);
    return k.createElement(tn, null, k.createElement(on, _I({
      id: n.name,
      type: "checkbox"
    }, n.input)), k.createElement(rn, {
      htmlFor: n.name,
      role: "switch",
      disabled: n.disabled
    }, k.createElement(an, {
      checked: e
    }, k.createElement("span", null))));
  }

  function A(n) {
    var e = n.input,
        t = n.field,
        r = n.options || t.options;
    return k.createElement(yn, null, k.createElement("select", _I({
      id: e.name,
      value: e.value,
      onChange: e.onChange
    }, e), r ? r.map(ln).map(sn) : k.createElement("option", null, e.value)));
  }

  var L,
      T,
      G,
      R,
      H,
      M,
      q,
      O,
      W,
      V,
      _,
      U = ((y = {})[F.RGB] = {
    getLabel: function getLabel(n) {
      return "R" + n.r + " G" + n.g + " B" + n.b;
    },
    getValue: function getValue(n) {
      var e = [n.r, n.g, n.b, n.a];
      return r.to.rgb(e);
    },
    parse: P
  }, y[F.Hex] = {
    getLabel: function getLabel(n) {
      return function (n) {
        return "#" + ((1 << 24) + (n.r << 16) + (n.g << 8) + n.b).toString(16).slice(1);
      }(n);
    },
    getValue: function getValue(n) {
      var e = [n.r, n.g, n.b, n.a];
      return r.to.hex(e);
    },
    parse: P
  }, y),
      K = a(function (n) {
    var e = n.colorRGBA,
        t = n.colorFormat,
        r = (n.unselectable, f(n, ["colorRGBA", "colorFormat", "unselectable"]));
    return k.createElement("div", _I({}, r), k.createElement("div", {
      className: "swatch-inner"
    }, e ? U[t].getLabel(e) : "Click to add color"));
  }).withConfig({
    displayName: "Swatch",
    componentId: "sc-en2mi4"
  })(L = L || i(["\n  background: var(--tina-color-grey-2);\n  border-radius: var(--tina-radius-big);\n  box-shadow: var(--tina-shadow-small);\n  cursor: pointer;\n  width: 100%;\n  margin: 0;\n\n  > div {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    font-size: var(--tina-font-size-1);\n    font-weight: bold;\n\n    width: 100%;\n    height: 40px;\n    border-radius: var(--tina-radius-big);\n    box-shadow: inset 0 0 1px 1px rgba(0, 0, 0, 0.075);\n    background: ", ";\n    color: ", ";\n    transition: all var(--tina-timing-short) ease-out;\n  }\n\n  &:hover {\n    > div {\n      opacity: 0.6;\n    }\n  }\n"], ["\n  background: var(--tina-color-grey-2);\n  border-radius: var(--tina-radius-big);\n  box-shadow: var(--tina-shadow-small);\n  cursor: pointer;\n  width: 100%;\n  margin: 0;\n\n  > div {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    font-size: var(--tina-font-size-1);\n    font-weight: bold;\n\n    width: 100%;\n    height: 40px;\n    border-radius: var(--tina-radius-big);\n    box-shadow: inset 0 0 1px 1px rgba(0, 0, 0, 0.075);\n    background: ", ";\n    color: ", ";\n    transition: all var(--tina-timing-short) ease-out;\n  }\n\n  &:hover {\n    > div {\n      opacity: 0.6;\n    }\n  }\n"]), function (n) {
    return n.colorRGBA ? "rgba(" + n.colorRGBA.r + ", " + n.colorRGBA.g + ", " + n.colorRGBA.b + ", " + n.colorRGBA.a + ")" : "#fff";
  }, function (n) {
    return function (n) {
      return !n || 186 < .299 * n.r + .587 * n.g + .114 * n.b ? "#000000" : "#ffffff";
    }(n.colorRGBA);
  }),
      Y = e.keyframes(T = T || i(["\n  0% {\n    transform: translate3d(-50%, 0, 0) scale3d(0.5,0.5,1)\n  }\n  100% {\n    transform: translate3d(-50%, 8px, 0) scale3d(1, 1, 1);\n  }\n"], ["\n  0% {\n    transform: translate3d(-50%, 0, 0) scale3d(0.5,0.5,1)\n  }\n  100% {\n    transform: translate3d(-50%, 8px, 0) scale3d(1, 1, 1);\n  }\n"])),
      J = e.keyframes(G = G || i(["\n  0% {\n    transform: translate3d(-50%, -100%, 0) scale3d(0.5,0.5,1)\n  }\n  100% {\n    transform: translate3d(-50%, calc(-100% - 8px), 0) scale3d(1, 1, 1);\n  }\n"], ["\n  0% {\n    transform: translate3d(-50%, -100%, 0) scale3d(0.5,0.5,1)\n  }\n  100% {\n    transform: translate3d(-50%, calc(-100% - 8px), 0) scale3d(1, 1, 1);\n  }\n"])),
      Q = a.div.withConfig({
    displayName: "Popover",
    componentId: "sc-1hjmdgw"
  })(H = H || i(["\n  position: fixed;\n  top: ", "px;\n  left: ", "px;\n  transform: translate3d(-50%, 8px, 0) scale3d(1, 1, 1);\n  transform-origin: 50% 0;\n  animation: ", " 85ms ease-out both 1;\n  z-index: var(--tina-z-index-4);\n\n  &:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 50%;\n    margin-top: 1px;\n    transform: translate3d(-50%, -100%, 0);\n    width: 18px;\n    height: 14px;\n    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\n    background-color: var(--tina-color-grey-3);\n    z-index: var(--tina-z-index-1);\n  }\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 50%;\n    margin-top: 2px;\n    transform: translate3d(-50%, -100%, 0);\n    width: 16px;\n    height: 13px;\n    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\n    background-color: white;\n    z-index: var(--tina-z-index-2);\n  }\n\n  ", ";\n"], ["\n  position: fixed;\n  top: ", "px;\n  left: ", "px;\n  transform: translate3d(-50%, 8px, 0) scale3d(1, 1, 1);\n  transform-origin: 50% 0;\n  animation: ", " 85ms ease-out both 1;\n  z-index: var(--tina-z-index-4);\n\n  &:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 50%;\n    margin-top: 1px;\n    transform: translate3d(-50%, -100%, 0);\n    width: 18px;\n    height: 14px;\n    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\n    background-color: var(--tina-color-grey-3);\n    z-index: var(--tina-z-index-1);\n  }\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 50%;\n    margin-top: 2px;\n    transform: translate3d(-50%, -100%, 0);\n    width: 16px;\n    height: 13px;\n    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\n    background-color: white;\n    z-index: var(--tina-z-index-2);\n  }\n\n  ", ";\n"]), function (n) {
    return n.triggerBoundingBox ? n.triggerBoundingBox.bottom : "0";
  }, function (n) {
    return n.triggerBoundingBox ? n.triggerBoundingBox.left + n.triggerBoundingBox.width / 2 : "0";
  }, Y, function (n) {
    return n.openTop && e.css(R = R || i(["\n      top: ", "px;\n      transform: translate3d(-50%, calc(-100% - 8px), 0) scale3d(1, 1, 1);\n      animation: ", " 85ms ease-out both 1;\n      transform-origin: 50% 100%;\n\n      &:before,\n      &:after {\n        top: auto;\n        bottom: 0;\n        transform: translate3d(-50%, 100%, 0);\n        clip-path: polygon(0% 0%, 100% 0%, 50% 100%);\n      }\n\n      &:before {\n        margin-top: 0;\n        margin-bottom: 1px;\n      }\n\n      &:after {\n        margin-top: 0;\n        margin-bottom: 2px;\n      }\n    "], ["\n      top: ", "px;\n      transform: translate3d(-50%, calc(-100% - 8px), 0) scale3d(1, 1, 1);\n      animation: ", " 85ms ease-out both 1;\n      transform-origin: 50% 100%;\n\n      &:before,\n      &:after {\n        top: auto;\n        bottom: 0;\n        transform: translate3d(-50%, 100%, 0);\n        clip-path: polygon(0% 0%, 100% 0%, 50% 100%);\n      }\n\n      &:before {\n        margin-top: 0;\n        margin-bottom: 1px;\n      }\n\n      &:after {\n        margin-top: 0;\n        margin-bottom: 2px;\n      }\n    "]), n.triggerBoundingBox ? n.triggerBoundingBox.top : "0", J);
  }),
      X = a.div.withConfig({
    displayName: "Cover",
    componentId: "sc-5kmbeh"
  })(M = M || i(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  z-index: var(--tina-z-index-1);\n"], ["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  z-index: var(--tina-z-index-1);\n"])),
      Z = a.div.withConfig({
    displayName: "ColorPickerWrapper",
    componentId: "sc-12817rs"
  })(q = q || i(["\n  position: relative;\n"], ["\n  position: relative;\n"])),
      $ = "transparent",
      nn = ["#D0021B", "#F5A623", "#F8E71C", "#8B572A", "#7ED321", "#417505", "#BD10E0", "#9013FE", "#4A90E2", "#50E3C2", "#B8E986", "#000000", "#4A4A4A", "#9B9B9B", "#FFFFFF"],
      en = {
    sketch: function sketch(n) {
      return k.createElement(t.SketchPicker, {
        presetColors: n.presetColors,
        color: n.color,
        onChange: n.onChange,
        disableAlpha: n.disableAlpha,
        width: n.width
      });
    },
    block: function block(n) {
      return k.createElement(t.BlockPicker, {
        colors: n.presetColors,
        color: n.color,
        onChange: n.onChange,
        width: n.width
      });
    }
  },
      tn = a.div.withConfig({
    displayName: "ToggleElement",
    componentId: "sc-uojt3t"
  })(O = O || i(["\n  display: block;\n  position: relative;\n  width: 48px;\n  height: 28px;\n  margin: 0;\n"], ["\n  display: block;\n  position: relative;\n  width: 48px;\n  height: 28px;\n  margin: 0;\n"])),
      rn = a.label.withConfig({
    displayName: "ToggleLabel",
    componentId: "sc-3k30ey"
  })(W = W || i(["\n  background: none;\n  color: inherit;\n  padding: 0;\n  opacity: ", ";\n  outline: none;\n  width: 48px;\n  height: 28px;\n  pointer-events: ", ";\n"], ["\n  background: none;\n  color: inherit;\n  padding: 0;\n  opacity: ", ";\n  outline: none;\n  width: 48px;\n  height: 28px;\n  pointer-events: ", ";\n"]), function (n) {
    return n.disabled ? "0.4" : "1";
  }, function (n) {
    return n.disabled ? "none" : "inherit";
  }),
      an = a.div.withConfig({
    displayName: "ToggleSwitch",
    componentId: "sc-1c99jht"
  })(V = V || i(["\n  position: relative;\n  width: 48px;\n  height: 28px;\n  border-radius: var(--tina-radius-big);\n  background-color: white;\n  border: 1px solid var(--tina-color-grey-2);\n  pointer-events: none;\n  margin-left: -2px;\n  span {\n    position: absolute;\n    border-radius: var(--tina-radius-big);\n    left: 2px;\n    top: 50%;\n    width: calc(28px - 6px);\n    height: calc(28px - 6px);\n    background: ", ";\n    border: 1px solid\n      ", ";\n    transform: translate3d(", ", -50%, 0);\n    transition: all 150ms ease-out;\n    box-shadow: var(--tina-shadow-big);\n  }\n"], ["\n  position: relative;\n  width: 48px;\n  height: 28px;\n  border-radius: var(--tina-radius-big);\n  background-color: white;\n  border: 1px solid var(--tina-color-grey-2);\n  pointer-events: none;\n  margin-left: -2px;\n  span {\n    position: absolute;\n    border-radius: var(--tina-radius-big);\n    left: 2px;\n    top: 50%;\n    width: calc(28px - 6px);\n    height: calc(28px - 6px);\n    background: ", ";\n    border: 1px solid\n      ", ";\n    transform: translate3d(", ", -50%, 0);\n    transition: all 150ms ease-out;\n    box-shadow: var(--tina-shadow-big);\n  }\n"]), function (n) {
    return n.checked ? "var(--tina-color-primary)" : "var(--tina-color-grey-4)";
  }, function (n) {
    return n.checked ? "var(--tina-color-primary-dark)" : "var(--tina-color-grey-5)";
  }, function (n) {
    return n.checked ? "20px" : "0";
  }),
      on = a.input.withConfig({
    displayName: "ToggleInput",
    componentId: "sc-1qup7ju"
  })(_ = _ || i(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 48px;\n  height: 28px;\n  opacity: 0;\n  margin: 0;\n  cursor: ", ";\n  pointer-events: auto;\n\n  &:hover {\n    + ", " ", " {\n      box-shadow: 0 0 0 2px var(--tina-color-grey-3);\n    }\n  }\n\n  &:focus {\n    + ", " ", " {\n      box-shadow: 0 0 0 2px var(--tina-color-primary);\n    }\n  }\n"], ["\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 48px;\n  height: 28px;\n  opacity: 0;\n  margin: 0;\n  cursor: ", ";\n  pointer-events: auto;\n\n  &:hover {\n    + ", " ", " {\n      box-shadow: 0 0 0 2px var(--tina-color-grey-3);\n    }\n  }\n\n  &:focus {\n    + ", " ", " {\n      box-shadow: 0 0 0 2px var(--tina-color-primary);\n    }\n  }\n"]), function (n) {
    return n.disabled ? "not-allowed" : "pointer";
  }, rn, an, rn, an);

  function ln(n) {
    return "object" == typeof n ? n : {
      value: n,
      label: n
    };
  }

  function sn(n) {
    return k.createElement("option", {
      key: n.value,
      value: n.value
    }, n.label);
  }

  function cn(n) {
    var e = n.onChange,
        t = n.value,
        r = n.step;
    return k.createElement(B, {
      type: "number",
      step: r,
      value: t,
      onChange: e
    });
  }

  function dn(n) {
    var e = n.onDrop,
        t = n.onClear,
        r = n.onClick,
        a = n.value,
        i = n.previewSrc,
        o = n.loading,
        l = d.useDropzone({
      accept: "image/*",
      onDrop: e,
      noClick: !!r
    }),
        s = l.getRootProps,
        c = l.getInputProps;
    return k.createElement(wn, _I({}, s(), {
      onClick: r
    }), k.createElement("input", _I({}, c())), a ? k.createElement(zn, null, o ? k.createElement(In, null) : k.createElement(k.Fragment, null, k.createElement(kn, {
      src: i
    }), t && k.createElement(Cn, {
      onClick: function onClick(n) {
        n.stopPropagation(), t();
      }
    }, k.createElement(u.TrashIcon, null)))) : k.createElement(En, null, "Drag 'n' drop some files here,", k.createElement("br", null), "or click to select files"));
  }

  var pn,
      un,
      gn,
      mn,
      fn,
      vn,
      hn,
      xn,
      bn,
      yn = a.div.withConfig({
    displayName: "SelectElement",
    componentId: "sc-exahe8"
  })(pn = pn || i(["\n  display: block;\n  position: relative;\n\n  select {\n    display: block;\n    font-family: inherit;\n    max-width: 100%;\n    padding: var(--tina-padding-small);\n    border-radius: var(--tina-radius-small);\n    background: var(--tina-color-grey-0);\n    font-size: var(--tina-font-size-2);\n    line-height: 1.35;\n    position: relative;\n    background-color: var(--tina-color-grey-0);\n    transition: all 85ms ease-out;\n    border: 1px solid var(--tina-color-grey-2);\n    width: 100%;\n    margin: 0;\n    appearance: none;\n    outline: none;\n    background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E');\n    background-repeat: no-repeat;\n    background-position: right 0.7em top 50%;\n    background-size: 0.65em auto;\n\n    &:hover {\n      box-shadow: 0 0 0 2px var(--tina-color-grey-3);\n    }\n\n    &:focus {\n      box-shadow: 0 0 0 2px var(--tina-color-primary);\n    }\n  }\n\n  select:-moz-focusring,\n  select::-moz-focus-inner {\n    color: transparent;\n    text-shadow: 0 0 0 #000;\n  }\n"], ["\n  display: block;\n  position: relative;\n\n  select {\n    display: block;\n    font-family: inherit;\n    max-width: 100%;\n    padding: var(--tina-padding-small);\n    border-radius: var(--tina-radius-small);\n    background: var(--tina-color-grey-0);\n    font-size: var(--tina-font-size-2);\n    line-height: 1.35;\n    position: relative;\n    background-color: var(--tina-color-grey-0);\n    transition: all 85ms ease-out;\n    border: 1px solid var(--tina-color-grey-2);\n    width: 100%;\n    margin: 0;\n    appearance: none;\n    outline: none;\n    background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E');\n    background-repeat: no-repeat;\n    background-position: right 0.7em top 50%;\n    background-size: 0.65em auto;\n\n    &:hover {\n      box-shadow: 0 0 0 2px var(--tina-color-grey-3);\n    }\n\n    &:focus {\n      box-shadow: 0 0 0 2px var(--tina-color-primary);\n    }\n  }\n\n  select:-moz-focusring,\n  select::-moz-focus-inner {\n    color: transparent;\n    text-shadow: 0 0 0 #000;\n  }\n"])),
      wn = a.div.withConfig({
    displayName: "DropArea",
    componentId: "sc-10mgiks"
  })(un = un || i(["\n  border-radius: var(--tina-radius-small);\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  outline: none;\n  cursor: pointer;\n"], ["\n  border-radius: var(--tina-radius-small);\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  outline: none;\n  cursor: pointer;\n"])),
      En = a.div.withConfig({
    displayName: "ImgPlaceholder",
    componentId: "sc-do3q3q"
  })(gn = gn || i(["\n  text-align: center;\n  border-radius: var(--tina-radius-small);\n  background-color: var(--tina-color-grey-2);\n  color: var(--tina-color-grey-4);\n  line-height: 1.35;\n  padding: 12px 0;\n  font-size: var(--tina-font-size-2);\n  font-weight: var(--tina-font-weight-regular);\n  transition: all 85ms ease-out;\n  &:hover {\n    opacity: 0.6;\n  }\n"], ["\n  text-align: center;\n  border-radius: var(--tina-radius-small);\n  background-color: var(--tina-color-grey-2);\n  color: var(--tina-color-grey-4);\n  line-height: 1.35;\n  padding: 12px 0;\n  font-size: var(--tina-font-size-2);\n  font-weight: var(--tina-font-weight-regular);\n  transition: all 85ms ease-out;\n  &:hover {\n    opacity: 0.6;\n  }\n"])),
      kn = a.img.withConfig({
    displayName: "StyledImage",
    componentId: "sc-6btb8n"
  })(vn = vn || i(["\n  max-width: 100%;\n  min-height: 100px;\n  border-radius: var(--tina-radius-small);\n  transition: opacity var(--tina-timing-short) ease-out;\n  margin: 0;\n  display: block;\n  background-color: #e1ddec;\n  background-size: auto;\n  background-position: center center;\n  background-repeat: no-repeat;\n  ", "\n"], ["\n  max-width: 100%;\n  min-height: 100px;\n  border-radius: var(--tina-radius-small);\n  transition: opacity var(--tina-timing-short) ease-out;\n  margin: 0;\n  display: block;\n  background-color: #e1ddec;\n  background-size: auto;\n  background-position: center center;\n  background-repeat: no-repeat;\n  ", "\n"]), function (n) {
    return n.src && (n.src.includes("png") || n.src.includes("svg")) ? e.css(mn = mn || i(["\n          background-image: none;\n        "], ["\n          background-image: none;\n        "])) : e.css(fn = fn || i(["\n          background-image: url(\"data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='40px' height='50px' viewBox='0 0 40 50' style='enable-background:new 0 0 40 50;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D%0A%3C/style%3E%3Cdefs%3E%3C/defs%3E%3Cpath class='st0' d='M16.09,24.97c-3.31,0.55-6.16-2.09-5.57-5.16c0.34-1.73,1.82-3.14,3.68-3.5c3.39-0.66,6.37,2.11,5.67,5.25 C19.48,23.28,17.96,24.66,16.09,24.97z M1.88,26.75c0-7.69,0-15.38,0-23.07C2,3.64,1.97,3.53,1.99,3.45c0.5-1.7,1.64-2.82,3.48-3.31 C5.57,0.12,5.71,0.14,5.75,0c7.31,0,14.63,0,21.94,0c0.03,0.1,0.12,0.08,0.2,0.1c0.96,0.2,1.77,0.63,2.47,1.28 c2.72,2.52,5.44,5.05,8.16,7.57c0.68,0.63,1.14,1.38,1.37,2.24c0.02,0.08-0.02,0.19,0.11,0.23c0,5.11,0,10.22,0,15.34h-4.76 c0-3.38,0-6.75,0-10.13c0-0.35-0.1-0.43-0.46-0.43c-3.21,0.01-6.42,0.01-9.63,0.01c-1.65,0-2.62-0.9-2.62-2.42 c0-2.94-0.01-5.89,0.01-8.83c0-0.46-0.14-0.54-0.6-0.53c-4.91,0.02-9.83,0.02-14.74,0c-0.44,0-0.57,0.09-0.57,0.52 c0.02,6.21,0.01,12.42,0.01,18.63c0,1.06,0,2.12,0,3.18H1.88z M27.28,11.46c0,0.31,0.14,0.34,0.41,0.34c2.25-0.01,4.5,0,6.75-0.01 c0.09,0,0.2,0.04,0.24,0c-2.46-2.28-4.92-4.56-7.39-6.85C27.29,7.1,27.3,9.28,27.28,11.46z M33.37,29.61c0,5.18-0.01,10.37,0,15.55 c0,0.35-0.1,0.43-0.46,0.43c-9.23-0.01-18.46-0.01-27.69,0c-0.44,0-0.45-0.17-0.45-0.48c0.01-5.17,0-10.33,0-15.5H0 c0,5.6,0,11.19,0,16.79c0.17,0.09,0.15,0.26,0.19,0.4c0.57,1.85,2.39,3.18,4.47,3.19c9.6,0.01,19.2,0.01,28.81,0 c2.08,0,3.89-1.33,4.47-3.19c0.04-0.14,0.02-0.31,0.19-0.4c0-5.6,0-11.19,0-16.79H33.37z M29.75,42.62c0.34,0,0.44-0.06,0.44-0.4 c-0.01-3.68-0.01-4.6-0.01-8.28c0-0.25-0.08-0.43-0.28-0.6c-0.62-0.55-1.22-1.13-1.83-1.69c-0.79-0.73-1.36-0.74-2.15-0.01 c-2.71,2.52-5.43,5.03-8.13,7.55c-0.26,0.25-0.39,0.24-0.65,0c-1.13-1.08-2.28-2.13-3.43-3.19c-0.7-0.65-1.31-0.65-2.01,0 c-1.16,1.07-2.31,2.15-3.48,3.22c-0.2,0.19-0.29,0.37-0.29,0.64c0.01,1.69,0.03,0.61,0,2.3c-0.01,0.41,0.14,0.46,0.53,0.46 c3.52-0.01,7.05-0.01,10.57-0.01C22.6,42.61,26.17,42.61,29.75,42.62z'/%3E%3C/svg%3E\");\n        "], ["\n          background-image: url(\"data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='40px' height='50px' viewBox='0 0 40 50' style='enable-background:new 0 0 40 50;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D%0A%3C/style%3E%3Cdefs%3E%3C/defs%3E%3Cpath class='st0' d='M16.09,24.97c-3.31,0.55-6.16-2.09-5.57-5.16c0.34-1.73,1.82-3.14,3.68-3.5c3.39-0.66,6.37,2.11,5.67,5.25 C19.48,23.28,17.96,24.66,16.09,24.97z M1.88,26.75c0-7.69,0-15.38,0-23.07C2,3.64,1.97,3.53,1.99,3.45c0.5-1.7,1.64-2.82,3.48-3.31 C5.57,0.12,5.71,0.14,5.75,0c7.31,0,14.63,0,21.94,0c0.03,0.1,0.12,0.08,0.2,0.1c0.96,0.2,1.77,0.63,2.47,1.28 c2.72,2.52,5.44,5.05,8.16,7.57c0.68,0.63,1.14,1.38,1.37,2.24c0.02,0.08-0.02,0.19,0.11,0.23c0,5.11,0,10.22,0,15.34h-4.76 c0-3.38,0-6.75,0-10.13c0-0.35-0.1-0.43-0.46-0.43c-3.21,0.01-6.42,0.01-9.63,0.01c-1.65,0-2.62-0.9-2.62-2.42 c0-2.94-0.01-5.89,0.01-8.83c0-0.46-0.14-0.54-0.6-0.53c-4.91,0.02-9.83,0.02-14.74,0c-0.44,0-0.57,0.09-0.57,0.52 c0.02,6.21,0.01,12.42,0.01,18.63c0,1.06,0,2.12,0,3.18H1.88z M27.28,11.46c0,0.31,0.14,0.34,0.41,0.34c2.25-0.01,4.5,0,6.75-0.01 c0.09,0,0.2,0.04,0.24,0c-2.46-2.28-4.92-4.56-7.39-6.85C27.29,7.1,27.3,9.28,27.28,11.46z M33.37,29.61c0,5.18-0.01,10.37,0,15.55 c0,0.35-0.1,0.43-0.46,0.43c-9.23-0.01-18.46-0.01-27.69,0c-0.44,0-0.45-0.17-0.45-0.48c0.01-5.17,0-10.33,0-15.5H0 c0,5.6,0,11.19,0,16.79c0.17,0.09,0.15,0.26,0.19,0.4c0.57,1.85,2.39,3.18,4.47,3.19c9.6,0.01,19.2,0.01,28.81,0 c2.08,0,3.89-1.33,4.47-3.19c0.04-0.14,0.02-0.31,0.19-0.4c0-5.6,0-11.19,0-16.79H33.37z M29.75,42.62c0.34,0,0.44-0.06,0.44-0.4 c-0.01-3.68-0.01-4.6-0.01-8.28c0-0.25-0.08-0.43-0.28-0.6c-0.62-0.55-1.22-1.13-1.83-1.69c-0.79-0.73-1.36-0.74-2.15-0.01 c-2.71,2.52-5.43,5.03-8.13,7.55c-0.26,0.25-0.39,0.24-0.65,0c-1.13-1.08-2.28-2.13-3.43-3.19c-0.7-0.65-1.31-0.65-2.01,0 c-1.16,1.07-2.31,2.15-3.48,3.22c-0.2,0.19-0.29,0.37-0.29,0.64c0.01,1.69,0.03,0.61,0,2.3c-0.01,0.41,0.14,0.46,0.53,0.46 c3.52-0.01,7.05-0.01,10.57-0.01C22.6,42.61,26.17,42.61,29.75,42.62z'/%3E%3C/svg%3E\");\n        "]));
  }),
      Cn = a(p.IconButton).withConfig({
    displayName: "DeleteButton",
    componentId: "sc-1dcbeyi"
  })(hn = hn || i(["\n  top: 8px;\n  right: 8px;\n  position: absolute;\n  &:not(:hover) {\n    fill: var(--tina-color-grey-0);\n    background-color: transparent;\n    border-color: transparent;\n  }\n"], ["\n  top: 8px;\n  right: 8px;\n  position: absolute;\n  &:not(:hover) {\n    fill: var(--tina-color-grey-0);\n    background-color: transparent;\n    border-color: transparent;\n  }\n"])),
      zn = a.div.withConfig({
    displayName: "StyledImageContainer",
    componentId: "sc-10590j4"
  })(xn = xn || i(["\n  background-color: var(--tina-color-grey-4);\n  position: relative;\n  border-radius: var(--tina-radius-small);\n  overflow: hidden;\n  background-color: var(--tina-color-grey-8);\n  &:hover {\n    ", " {\n      opacity: 0.6;\n    }\n  }\n"], ["\n  background-color: var(--tina-color-grey-4);\n  position: relative;\n  border-radius: var(--tina-radius-small);\n  overflow: hidden;\n  background-color: var(--tina-color-grey-8);\n  &:hover {\n    ", " {\n      opacity: 0.6;\n    }\n  }\n"]), kn),
      In = function In() {
    return k.createElement(Fn, null, k.createElement(z.LoadingDots, null));
  },
      Fn = a.div.withConfig({
    displayName: "ImageLoaderWrapper",
    componentId: "sc-1su3ym4"
  })(bn = bn || i(["\n  padding: 1rem;\n  width: 100%;\n  min-height: 6rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"], ["\n  padding: 1rem;\n  width: 100%;\n  min-height: 6rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"]));

  function Bn(e) {
    return function (n) {
      return k.createElement(Nn, {
        name: n.input.name,
        label: n.field.label,
        description: n.field.description,
        error: n.meta.error
      }, k.createElement(e, _I({}, n)));
    };
  }

  function Nn(n) {
    var e = n.name,
        t = n.label,
        r = n.description,
        a = n.error,
        i = n.margin,
        o = void 0 === i || i,
        l = n.children;
    return k.createElement(Ln, {
      margin: o
    }, k.createElement(Tn, {
      htmlFor: e
    }, t || e, r && k.createElement(Gn, null, r)), l, a && k.createElement(Rn, null, a));
  }

  var Dn,
      Pn,
      jn,
      Sn,
      An,
      Ln = a.div.withConfig({
    displayName: "FieldWrapper",
    componentId: "sc-1frw1ic"
  })(Pn = Pn || i(["\n  position: relative;\n\n  ", ";\n"], ["\n  position: relative;\n\n  ", ";\n"]), function (n) {
    return n.margin && e.css(Dn = Dn || i(["\n      margin-bottom: var(--tina-padding-big);\n    "], ["\n      margin-bottom: var(--tina-padding-big);\n    "]));
  }),
      Tn = a.label.withConfig({
    displayName: "FieldLabel",
    componentId: "sc-kpki66"
  })(jn = jn || i(["\n  all: unset;\n  font-family: 'Inter', sans-serif;\n  display: block;\n  font-size: var(--tina-font-size-1);\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  line-height: 1.35;\n  color: var(--tina-color-grey-8);\n  margin-bottom: 8px;\n  text-overflow: ellipsis;\n  width: 100%;\n  overflow: hidden;\n"], ["\n  all: unset;\n  font-family: 'Inter', sans-serif;\n  display: block;\n  font-size: var(--tina-font-size-1);\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  line-height: 1.35;\n  color: var(--tina-color-grey-8);\n  margin-bottom: 8px;\n  text-overflow: ellipsis;\n  width: 100%;\n  overflow: hidden;\n"])),
      Gn = a.span.withConfig({
    displayName: "FieldDescription",
    componentId: "sc-kyuv0c"
  })(Sn = Sn || i(["\n  all: unset;\n  display: block;\n  font-family: 'Inter', sans-serif;\n  font-size: var(--tina-font-size-0);\n  font-style: italic;\n  font-weight: lighter;\n  color: var(--tina-color-grey-6);\n  padding-top: 4px;\n  white-space: normal;\n  margin: 0;\n"], ["\n  all: unset;\n  display: block;\n  font-family: 'Inter', sans-serif;\n  font-size: var(--tina-font-size-0);\n  font-style: italic;\n  font-weight: lighter;\n  color: var(--tina-color-grey-6);\n  padding-top: 4px;\n  white-space: normal;\n  margin: 0;\n"])),
      Rn = a.span.withConfig({
    displayName: "FieldError",
    componentId: "sc-1wd9zf8"
  })(An = An || i(["\n  display: block;\n  color: red;\n  font-size: var(--tina-font-size-1);\n  margin-top: 8px;\n  font-weight: var(--tina-font-weight-regular);\n"], ["\n  display: block;\n  color: red;\n  font-size: var(--tina-font-size-1);\n  margin-top: 8px;\n  font-weight: var(--tina-font-weight-regular);\n"])),
      Hn = Bn(function (n) {
    var e = n.tinaForm,
        t = n.field,
        r = k.useState(!1),
        a = r[0],
        i = r[1];
    return k.createElement(k.Fragment, null, k.createElement(qn, {
      onClick: function onClick() {
        return i(function (n) {
          return !n;
        });
      }
    }, t.label || t.name, k.createElement(u.RightArrowIcon, null)), k.createElement(Mn, {
      isExpanded: a,
      setExpanded: i,
      field: t,
      tinaForm: e
    }));
  }),
      Mn = function Mn(n) {
    var e = n.setExpanded,
        t = n.isExpanded,
        r = n.tinaForm,
        a = n.field,
        i = z.useFormPortal(),
        o = k.useMemo(function () {
      return a.fields.map(function (n) {
        return _I(_I({}, n), {
          name: a.name + "." + n.name
        });
      });
    }, [a.fields, a.name]);
    return k.createElement(i, null, k.createElement(_n, {
      isExpanded: t
    }, k.createElement(On, {
      onClick: function onClick() {
        return e(!1);
      }
    }, k.createElement(u.LeftArrowIcon, null), " ", k.createElement("span", null, a.label || a.name)), k.createElement(Wn, null, t ? k.createElement(c.FieldsBuilder, {
      form: r,
      fields: o
    }) : null)));
  },
      qn = a.div.withConfig({
    displayName: "Header",
    componentId: "sc-gn6gb4"
  })(Kn = Kn || i(["\n  position: relative;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border: 1px solid var(--tina-color-grey-2);\n  border-radius: var(--tina-radius-small);\n  margin: 0 0 24px 0;\n  overflow: visible;\n  line-height: 1.35;\n  padding: 12px;\n  color: var(--tina-color-grey-10);\n  background-color: white;\n\n  svg {\n    width: 24px;\n    height: auto;\n    fill: var(--tina-color-grey-3);\n    transition: all var(--tina-timing-short) ease-out;\n  }\n\n  &:hover {\n    svg {\n      fill: var(--tina-color-grey-8);\n    }\n    color: #0084ff;\n  }\n"], ["\n  position: relative;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border: 1px solid var(--tina-color-grey-2);\n  border-radius: var(--tina-radius-small);\n  margin: 0 0 24px 0;\n  overflow: visible;\n  line-height: 1.35;\n  padding: 12px;\n  color: var(--tina-color-grey-10);\n  background-color: white;\n\n  svg {\n    width: 24px;\n    height: auto;\n    fill: var(--tina-color-grey-3);\n    transition: all var(--tina-timing-short) ease-out;\n  }\n\n  &:hover {\n    svg {\n      fill: var(--tina-color-grey-8);\n    }\n    color: #0084ff;\n  }\n"])),
      On = a.div.withConfig({
    displayName: "PanelHeader",
    componentId: "sc-14yjils"
  })(Yn = Yn || i(["\n  position: relative;\n  width: 100%;\n  cursor: pointer;\n  background-color: white;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  padding: 6px 18px 6px 18px;\n  color: inherit;\n  font-size: var(--tina-font-size-3);\n  transition: color var(--tina-timing-medium) ease-out;\n  user-select: none;\n  border-bottom: 1px solid var(--tina-color-grey-2);\n  margin: 0;\n  span {\n    flex: 1 1 auto;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  svg {\n    flex: 0 0 auto;\n    width: 24px;\n    fill: var(--tina-color-grey-3);\n    height: auto;\n    transform: translate3d(-4px, 0, 0);\n    transition: transform var(--tina-timing-medium) ease-out;\n  }\n  :hover {\n    color: var(--tina-color-primary);\n    svg {\n      fill: var(--tina-color-grey-8);\n      transform: translate3d(-7px, 0, 0);\n      transition: transform var(--tina-timing-medium) ease-out;\n    }\n  }\n"], ["\n  position: relative;\n  width: 100%;\n  cursor: pointer;\n  background-color: white;\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  padding: 6px 18px 6px 18px;\n  color: inherit;\n  font-size: var(--tina-font-size-3);\n  transition: color var(--tina-timing-medium) ease-out;\n  user-select: none;\n  border-bottom: 1px solid var(--tina-color-grey-2);\n  margin: 0;\n  span {\n    flex: 1 1 auto;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n  svg {\n    flex: 0 0 auto;\n    width: 24px;\n    fill: var(--tina-color-grey-3);\n    height: auto;\n    transform: translate3d(-4px, 0, 0);\n    transition: transform var(--tina-timing-medium) ease-out;\n  }\n  :hover {\n    color: var(--tina-color-primary);\n    svg {\n      fill: var(--tina-color-grey-8);\n      transform: translate3d(-7px, 0, 0);\n      transition: transform var(--tina-timing-medium) ease-out;\n    }\n  }\n"])),
      Wn = a.div.withConfig({
    displayName: "PanelBody",
    componentId: "sc-1dpiq97"
  })(Jn = Jn || i(["\n  background: var(--tina-color-grey-1);\n  position: relative;\n  display: flex;\n  flex: 1 1 auto;\n  overflow-y: auto;\n"], ["\n  background: var(--tina-color-grey-1);\n  position: relative;\n  display: flex;\n  flex: 1 1 auto;\n  overflow-y: auto;\n"])),
      Vn = e.keyframes(Qn = Qn || i(["\n  0% {\n    transform: translate3d( 100%, 0, 0 );\n  }\n  100% {\n    transform: translate3d( 0, 0, 0 );\n  }\n"], ["\n  0% {\n    transform: translate3d( 100%, 0, 0 );\n  }\n  100% {\n    transform: translate3d( 0, 0, 0 );\n  }\n"])),
      _n = a.div.withConfig({
    displayName: "GroupPanel",
    componentId: "sc-1mqtfsb"
  })($n = $n || i(["\n  position: absolute;\n  width: 100%;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  overflow: hidden;\n  z-index: var(--tina-z-index-1);\n  pointer-events: ", ";\n\n  > * {\n    ", ";\n\n    ", ";\n  }\n"], ["\n  position: absolute;\n  width: 100%;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  overflow: hidden;\n  z-index: var(--tina-z-index-1);\n  pointer-events: ", ";\n\n  > * {\n    ", ";\n\n    ", ";\n  }\n"]), function (n) {
    return n.isExpanded ? "all" : "none";
  }, function (n) {
    return n.isExpanded && e.css(Xn = Xn || i(["\n        animation-name: ", ";\n        animation-duration: 150ms;\n        animation-delay: 0;\n        animation-iteration-count: 1;\n        animation-timing-function: ease-out;\n        animation-fill-mode: backwards;\n      "], ["\n        animation-name: ", ";\n        animation-duration: 150ms;\n        animation-delay: 0;\n        animation-iteration-count: 1;\n        animation-timing-function: ease-out;\n        animation-fill-mode: backwards;\n      "]), Vn);
  }, function (n) {
    return !n.isExpanded && e.css(Zn = Zn || i(["\n        transition: transform 150ms ease-out;\n        transform: translate3d(100%, 0, 0);\n      "], ["\n        transition: transform 150ms ease-out;\n        transform: translate3d(100%, 0, 0);\n      "]));
  });

  function Un(n) {
    return n || "";
  }

  var Kn,
      Yn,
      Jn,
      Qn,
      Xn,
      Zn,
      $n,
      ne,
      ee,
      te,
      re,
      ae,
      ie,
      oe,
      le,
      se,
      ce,
      de,
      pe,
      ue,
      ge,
      me,
      fe,
      ve,
      he,
      xe,
      be,
      ye,
      we,
      Ee,
      ke,
      Ce,
      ze,
      Ie,
      Fe,
      Be,
      Ne,
      De,
      Pe,
      je,
      Se,
      Ae,
      Le,
      Te,
      Ge = {
    name: "group",
    Component: Hn
  },
      Re = function Re() {
    return k.createElement(_e, null, "There are no items");
  },
      He = function He(n) {
    var t = n.tinaForm,
        r = n.field,
        a = n.index,
        e = (n.item, n.label),
        i = f(n, ["tinaForm", "field", "index", "item", "label"]),
        o = z.useFormPortal(),
        l = k.useState(!1),
        s = l[0],
        c = l[1],
        d = k.useCallback(function () {
      t.mutators.remove(r.name, a);
    }, [t, r, a]),
        p = e || (r.label || r.name) + " Item";
    return k.createElement(g.Draggable, {
      type: r.name,
      draggableId: r.name + "." + a,
      index: a
    }, function (n, e) {
      return k.createElement(k.Fragment, null, k.createElement(Ke, _I({
        ref: n.innerRef,
        isDragging: e.isDragging
      }, n.draggableProps, n.dragHandleProps, i), k.createElement(Je, null), k.createElement(Me, {
        onClick: function onClick() {
          return c(!0);
        }
      }, k.createElement(qe, null, p)), k.createElement(Ye, {
        onClick: d
      }, k.createElement(u.TrashIcon, null))), k.createElement(o, null, k.createElement(Qe, {
        isExpanded: s,
        setExpanded: c,
        field: r,
        index: a,
        tinaForm: t,
        itemTitle: p
      })));
    });
  },
      Me = a.div.withConfig({
    displayName: "ItemClickTarget",
    componentId: "sc-f2s2jb"
  })(ne = ne || i(["\n  flex: 1 1 0;\n  min-width: 0;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px;\n"], ["\n  flex: 1 1 0;\n  min-width: 0;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px;\n"])),
      qe = a.span.withConfig({
    displayName: "GroupLabel",
    componentId: "sc-1xm9m52"
  })(te = te || i(["\n  margin: 0;\n  font-size: var(--tina-font-size-1);\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  line-height: 1.35;\n  flex: 1 1 auto;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: var(--tina-color-grey-8);\n  transition: all 85ms ease-out;\n  text-align: left;\n\n  ", ";\n"], ["\n  margin: 0;\n  font-size: var(--tina-font-size-1);\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  line-height: 1.35;\n  flex: 1 1 auto;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: var(--tina-color-grey-8);\n  transition: all 85ms ease-out;\n  text-align: left;\n\n  ", ";\n"]), function (n) {
    return n.error && e.css(ee = ee || i(["\n      color: var(--tina-color-error) !important;\n    "], ["\n      color: var(--tina-color-error) !important;\n    "]));
  }),
      Oe = a.div.withConfig({
    displayName: "GroupListHeader",
    componentId: "sc-2gg5me"
  })(re = re || i(["\n  position: relative;\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n  ", " {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n"], ["\n  position: relative;\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n  ", " {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n"]), Gn),
      We = a.div.withConfig({
    displayName: "GroupListMeta",
    componentId: "sc-cuc5w"
  })(ae = ae || i(["\n  line-height: 1;\n"], ["\n  line-height: 1;\n"])),
      Ve = a.div.withConfig({
    displayName: "GroupListPanel",
    componentId: "sc-1n9pz25"
  })(ie = ie || i(["\n  max-height: initial;\n  position: relative;\n  height: auto;\n  margin-bottom: 24px;\n  border-radius: var(--tina-radius-small);\n  background-color: var(--tina-color-grey-2);\n"], ["\n  max-height: initial;\n  position: relative;\n  height: auto;\n  margin-bottom: 24px;\n  border-radius: var(--tina-radius-small);\n  background-color: var(--tina-color-grey-2);\n"])),
      _e = a.div.withConfig({
    displayName: "EmptyList",
    componentId: "sc-as4ipn"
  })(oe = oe || i(["\n  text-align: center;\n  border-radius: var(--tina-radius-small);\n  background-color: var(--tina-color-grey-2);\n  color: var(--tina-color-grey-4);\n  line-height: 1.35;\n  padding: 12px 0;\n  font-size: var(--tina-font-size-2);\n  font-weight: var(--tina-font-weight-regular);\n"], ["\n  text-align: center;\n  border-radius: var(--tina-radius-small);\n  background-color: var(--tina-color-grey-2);\n  color: var(--tina-color-grey-4);\n  line-height: 1.35;\n  padding: 12px 0;\n  font-size: var(--tina-font-size-2);\n  font-weight: var(--tina-font-weight-regular);\n"])),
      Ue = a.div.withConfig({
    displayName: "ItemList",
    componentId: "sc-10iwsnx"
  })(le = le || i([""], [""])),
      Ke = a.div.withConfig({
    displayName: "ItemHeader",
    componentId: "sc-qm41so"
  })(ce = ce || i(["\n  position: relative;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n  background-color: white;\n  border: 1px solid var(--tina-color-grey-2);\n  margin: 0 0 -1px 0;\n  overflow: visible;\n  line-height: 1.35;\n  padding: 0;\n  font-size: var(--tina-font-size-2);\n  font-weight: var(--tina-font-weight-regular);\n\n  ", " {\n    color: var(--tina-color-grey-8);\n    align-self: center;\n    max-width: 100%;\n  }\n\n  svg {\n    fill: var(--tina-color-grey-3);\n    width: 20px;\n    height: auto;\n    transition: fill 85ms ease-out;\n  }\n\n  &:hover {\n    svg {\n      fill: var(--tina-color-grey-8);\n    }\n    ", " {\n      color: var(--tina-color-primary);\n    }\n  }\n\n  &:first-child {\n    border-radius: 4px 4px 0 0;\n  }\n\n  &:nth-last-child(2) {\n    border-radius: 0 0 4px 4px;\n    &:first-child {\n      border-radius: var(--tina-radius-small);\n    }\n  }\n\n  ", ";\n"], ["\n  position: relative;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n  background-color: white;\n  border: 1px solid var(--tina-color-grey-2);\n  margin: 0 0 -1px 0;\n  overflow: visible;\n  line-height: 1.35;\n  padding: 0;\n  font-size: var(--tina-font-size-2);\n  font-weight: var(--tina-font-weight-regular);\n\n  ", " {\n    color: var(--tina-color-grey-8);\n    align-self: center;\n    max-width: 100%;\n  }\n\n  svg {\n    fill: var(--tina-color-grey-3);\n    width: 20px;\n    height: auto;\n    transition: fill 85ms ease-out;\n  }\n\n  &:hover {\n    svg {\n      fill: var(--tina-color-grey-8);\n    }\n    ", " {\n      color: var(--tina-color-primary);\n    }\n  }\n\n  &:first-child {\n    border-radius: 4px 4px 0 0;\n  }\n\n  &:nth-last-child(2) {\n    border-radius: 0 0 4px 4px;\n    &:first-child {\n      border-radius: var(--tina-radius-small);\n    }\n  }\n\n  ", ";\n"]), qe, qe, function (n) {
    return n.isDragging && e.css(se = se || i(["\n      border-radius: var(--tina-radius-small);\n      box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.12);\n\n      svg {\n        fill: var(--tina-color-grey-8);\n      }\n      ", " {\n        color: var(--tina-color-primary);\n      }\n\n      ", " {\n        svg:first-child {\n          opacity: 0;\n        }\n        svg:last-child {\n          opacity: 1;\n        }\n      }\n    "], ["\n      border-radius: var(--tina-radius-small);\n      box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.12);\n\n      svg {\n        fill: var(--tina-color-grey-8);\n      }\n      ", " {\n        color: var(--tina-color-primary);\n      }\n\n      ", " {\n        svg:first-child {\n          opacity: 0;\n        }\n        svg:last-child {\n          opacity: 1;\n        }\n      }\n    "]), qe, Je);
  }),
      Ye = a.button.withConfig({
    displayName: "DeleteButton",
    componentId: "sc-6sbxj0"
  })(de = de || i(["\n  text-align: center;\n  flex: 0 0 auto;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  padding: 12px 8px;\n  margin: 0;\n  transition: all 85ms ease-out;\n  svg {\n    transition: all 85ms ease-out;\n  }\n  &:hover {\n    background-color: var(--tina-color-grey-1);\n  }\n"], ["\n  text-align: center;\n  flex: 0 0 auto;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  padding: 12px 8px;\n  margin: 0;\n  transition: all 85ms ease-out;\n  svg {\n    transition: all 85ms ease-out;\n  }\n  &:hover {\n    background-color: var(--tina-color-grey-1);\n  }\n"])),
      Je = a(function (n) {
    var e = f(n, []);
    return k.createElement("div", _I({}, e), k.createElement(u.DragIcon, null), k.createElement(u.ReorderIcon, null));
  }).withConfig({
    displayName: "DragHandle",
    componentId: "sc-m7fqse"
  })(pe = pe || i(["\n  margin: 0;\n  flex: 0 0 auto;\n  width: 32px;\n  position: relative;\n  fill: inherit;\n  padding: 12px 0;\n  transition: all 85ms ease-out;\n  &:hover {\n    background-color: var(--tina-color-grey-1);\n    cursor: grab;\n  }\n  svg {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    width: 20px;\n    height: 20px;\n    transform: translate3d(-50%, -50%, 0);\n    transition: all 85ms ease-out;\n  }\n  svg:last-child {\n    opacity: 0;\n  }\n  *:hover > & {\n    svg:first-child {\n      opacity: 0;\n    }\n    svg:last-child {\n      opacity: 1;\n    }\n  }\n"], ["\n  margin: 0;\n  flex: 0 0 auto;\n  width: 32px;\n  position: relative;\n  fill: inherit;\n  padding: 12px 0;\n  transition: all 85ms ease-out;\n  &:hover {\n    background-color: var(--tina-color-grey-1);\n    cursor: grab;\n  }\n  svg {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    width: 20px;\n    height: 20px;\n    transform: translate3d(-50%, -50%, 0);\n    transition: all 85ms ease-out;\n  }\n  svg:last-child {\n    opacity: 0;\n  }\n  *:hover > & {\n    svg:first-child {\n      opacity: 0;\n    }\n    svg:last-child {\n      opacity: 1;\n    }\n  }\n"])),
      Qe = function Qe(n) {
    var e = n.setExpanded,
        t = n.isExpanded,
        r = n.tinaForm,
        a = n.field,
        i = n.index,
        o = n.itemTitle,
        l = k.useMemo(function () {
      return a.fields.map(function (n) {
        return _I(_I({}, n), {
          name: a.name + "." + i + "." + n.name
        });
      });
    }, [a.fields, a.name, i]);
    return k.createElement(_n, {
      isExpanded: t
    }, k.createElement(On, {
      onClick: function onClick() {
        return e(!1);
      }
    }, k.createElement(u.LeftArrowIcon, null), k.createElement(qe, null, o)), k.createElement(Wn, null, t ? k.createElement(c.FieldsBuilder, {
      form: r,
      fields: l
    }) : null));
  },
      Xe = {
    name: "group-list",
    Component: function Component(n) {
      var t = n.tinaForm,
          e = n.form,
          r = n.field,
          a = n.input,
          i = k.useCallback(function () {
        var n = {};
        n = "function" == typeof r.defaultItem ? r.defaultItem() : r.defaultItem || {}, e.mutators.insert(r.name, 0, n);
      }, [e, r]),
          o = a.value || [],
          l = k.useCallback(function (n) {
        return r.itemProps ? r.itemProps(n) : {};
      }, [r.itemProps]);
      return k.createElement(k.Fragment, null, k.createElement(Oe, null, k.createElement(We, null, k.createElement(qe, null, r.label || r.name), r.description && k.createElement(Gn, null, r.description)), k.createElement(p.IconButton, {
        onClick: i,
        primary: !0,
        small: !0
      }, k.createElement(u.AddIcon, null))), k.createElement(Ve, null, k.createElement(Ue, null, k.createElement(g.Droppable, {
        droppableId: r.name,
        type: r.name
      }, function (n) {
        return k.createElement("div", {
          ref: n.innerRef
        }, 0 === o.length && k.createElement(Re, null), o.map(function (n, e) {
          return k.createElement(He, _I({
            key: e,
            tinaForm: t,
            field: r,
            item: n,
            index: e
          }, l(n)));
        }), n.placeholder);
      }))));
    }
  },
      Ze = function Ze() {
    return k.createElement(et, null, "There are no items");
  },
      $e = function $e(n) {
    var t = n.label,
        r = n.tinaForm,
        a = n.field,
        i = n.index,
        o = n.template,
        l = n.block,
        s = z.useFormPortal(),
        e = k.useState(!1),
        c = e[0],
        d = e[1],
        p = k.useCallback(function () {
      r.mutators.remove(a.name, i);
    }, [r, a, i]);
    return k.createElement(g.Draggable, {
      key: i,
      type: a.name,
      draggableId: a.name + "." + i,
      index: i
    }, function (n, e) {
      return k.createElement(k.Fragment, null, k.createElement(st, _I({
        ref: n.innerRef,
        isDragging: e.isDragging
      }, n.draggableProps, n.dragHandleProps), k.createElement(dt, null), k.createElement(it, {
        onClick: function onClick() {
          return d(!0);
        }
      }, k.createElement(qe, null, t || o.label)), k.createElement(ct, {
        onClick: p
      }, k.createElement(u.TrashIcon, null))), k.createElement(s, null, k.createElement(pt, {
        isExpanded: c,
        setExpanded: d,
        field: a,
        item: l,
        index: i,
        tinaForm: r,
        label: t || o.label,
        template: o
      })));
    });
  },
      nt = function nt(n) {
    var e = n.tinaForm,
        t = n.field,
        r = n.index,
        a = k.useCallback(function () {
      e.mutators.remove(t.name, r);
    }, [e, t, r]);
    return k.createElement(g.Draggable, {
      key: r,
      type: t.name,
      draggableId: t.name + "." + r,
      index: r
    }, function (n, e) {
      return k.createElement(st, _I({
        ref: n.innerRef,
        isDragging: e.isDragging
      }, n.draggableProps, n.dragHandleProps), k.createElement(dt, null), k.createElement(it, null, k.createElement(qe, {
        error: !0
      }, "Invalid Block")), k.createElement(ct, {
        onClick: a
      }, k.createElement(u.TrashIcon, null)));
    });
  },
      et = a.div.withConfig({
    displayName: "EmptyList",
    componentId: "sc-1r10bac"
  })(ue = ue || i(["\n  text-align: center;\n  border-radius: var(--tina-radius-small);\n  background-color: var(--tina-color-grey-2);\n  color: var(--tina-color-grey-4);\n  line-height: 1.35;\n  padding: 12px 0;\n  font-size: var(--tina-font-size-2);\n  font-weight: var(--tina-font-weight-regular);\n"], ["\n  text-align: center;\n  border-radius: var(--tina-radius-small);\n  background-color: var(--tina-color-grey-2);\n  color: var(--tina-color-grey-4);\n  line-height: 1.35;\n  padding: 12px 0;\n  font-size: var(--tina-font-size-2);\n  font-weight: var(--tina-font-weight-regular);\n"])),
      tt = a.div.withConfig({
    displayName: "BlockMenu",
    componentId: "sc-6b98k6"
  })(me = me || i(["\n  min-width: 192px;\n  border-radius: var(--tina-radius-big);\n  border: 1px solid #efefef;\n  display: block;\n  position: absolute;\n  top: 0;\n  right: 0;\n  transform: translate3d(0, 0, 0) scale3d(0.5, 0.5, 1);\n  opacity: 0;\n  pointer-events: none;\n  transition: all 150ms ease-out;\n  transform-origin: 100% 0;\n  box-shadow: var(--tina-shadow-big);\n  background-color: white;\n  overflow: hidden;\n  z-index: var(--tina-z-index-1);\n  ", ";\n"], ["\n  min-width: 192px;\n  border-radius: var(--tina-radius-big);\n  border: 1px solid #efefef;\n  display: block;\n  position: absolute;\n  top: 0;\n  right: 0;\n  transform: translate3d(0, 0, 0) scale3d(0.5, 0.5, 1);\n  opacity: 0;\n  pointer-events: none;\n  transition: all 150ms ease-out;\n  transform-origin: 100% 0;\n  box-shadow: var(--tina-shadow-big);\n  background-color: white;\n  overflow: hidden;\n  z-index: var(--tina-z-index-1);\n  ", ";\n"]), function (n) {
    return n.open && e.css(ge = ge || i(["\n      opacity: 1;\n      pointer-events: all;\n      transform: translate3d(0, 36px, 0) scale3d(1, 1, 1);\n    "], ["\n      opacity: 1;\n      pointer-events: all;\n      transform: translate3d(0, 36px, 0) scale3d(1, 1, 1);\n    "]));
  }),
      rt = a.div.withConfig({
    displayName: "BlockMenuList",
    componentId: "sc-1nyy6e7"
  })(fe = fe || i(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])),
      at = a.button.withConfig({
    displayName: "BlockOption",
    componentId: "sc-4izele"
  })(ve = ve || i(["\n  position: relative;\n  text-align: center;\n  font-size: var(--tina-font-size-0);\n  padding: var(--tina-padding-small);\n  font-weight: var(--tina-font-weight-regular);\n  width: 100%;\n  background: none;\n  cursor: pointer;\n  outline: none;\n  border: 0;\n  transition: all 85ms ease-out;\n  &:hover {\n    color: var(--tina-color-primary);\n    background-color: var(--tina-color-grey-1);\n  }\n  &:not(:last-child) {\n    border-bottom: 1px solid #efefef;\n  }\n"], ["\n  position: relative;\n  text-align: center;\n  font-size: var(--tina-font-size-0);\n  padding: var(--tina-padding-small);\n  font-weight: var(--tina-font-weight-regular);\n  width: 100%;\n  background: none;\n  cursor: pointer;\n  outline: none;\n  border: 0;\n  transition: all 85ms ease-out;\n  &:hover {\n    color: var(--tina-color-primary);\n    background-color: var(--tina-color-grey-1);\n  }\n  &:not(:last-child) {\n    border-bottom: 1px solid #efefef;\n  }\n"])),
      it = a.div.withConfig({
    displayName: "ItemClickTarget",
    componentId: "sc-1hyr910"
  })(he = he || i(["\n  flex: 1 1 0;\n  min-width: 0;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px;\n"], ["\n  flex: 1 1 0;\n  min-width: 0;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px;\n"])),
      ot = a.div.withConfig({
    displayName: "GroupListPanel",
    componentId: "sc-1k84d3v"
  })(xe = xe || i(["\n  max-height: initial;\n  position: relative;\n  height: auto;\n  margin-bottom: 24px;\n  border-radius: var(--tina-radius-small);\n  background-color: var(--tina-color-grey-2);\n"], ["\n  max-height: initial;\n  position: relative;\n  height: auto;\n  margin-bottom: 24px;\n  border-radius: var(--tina-radius-small);\n  background-color: var(--tina-color-grey-2);\n"])),
      lt = a.div.withConfig({
    displayName: "ItemList",
    componentId: "sc-1hwbkec"
  })(be = be || i([""], [""])),
      st = a.div.withConfig({
    displayName: "ItemHeader",
    componentId: "sc-15jdhoa"
  })(we = we || i(["\n  position: relative;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n  background-color: white;\n  border: 1px solid var(--tina-color-grey-2);\n  margin: 0 0 -1px 0;\n  overflow: visible;\n  line-height: 1.35;\n  padding: 0;\n  font-size: var(--tina-font-size-2);\n  font-weight: var(--tina-font-weight-regular);\n\n  ", " {\n    color: var(--tina-color-grey-10);\n    align-self: center;\n    max-width: 100%;\n  }\n\n  svg {\n    fill: var(--tina-color-grey-3);\n    width: 20px;\n    height: auto;\n    transition: fill 85ms ease-out;\n  }\n\n  &:hover {\n    svg {\n      fill: var(--tina-color-grey-8);\n    }\n    ", " {\n      color: var(--tina-color-primary);\n    }\n  }\n\n  &:first-child {\n    border-radius: 4px 4px 0 0;\n  }\n\n  &:nth-last-child(2) {\n    border-radius: 0 0 4px 4px;\n    &:first-child {\n      border-radius: var(--tina-radius-small);\n    }\n  }\n\n  ", ";\n"], ["\n  position: relative;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n  background-color: white;\n  border: 1px solid var(--tina-color-grey-2);\n  margin: 0 0 -1px 0;\n  overflow: visible;\n  line-height: 1.35;\n  padding: 0;\n  font-size: var(--tina-font-size-2);\n  font-weight: var(--tina-font-weight-regular);\n\n  ", " {\n    color: var(--tina-color-grey-10);\n    align-self: center;\n    max-width: 100%;\n  }\n\n  svg {\n    fill: var(--tina-color-grey-3);\n    width: 20px;\n    height: auto;\n    transition: fill 85ms ease-out;\n  }\n\n  &:hover {\n    svg {\n      fill: var(--tina-color-grey-8);\n    }\n    ", " {\n      color: var(--tina-color-primary);\n    }\n  }\n\n  &:first-child {\n    border-radius: 4px 4px 0 0;\n  }\n\n  &:nth-last-child(2) {\n    border-radius: 0 0 4px 4px;\n    &:first-child {\n      border-radius: var(--tina-radius-small);\n    }\n  }\n\n  ", ";\n"]), qe, qe, function (n) {
    return n.isDragging && e.css(ye = ye || i(["\n      border-radius: var(--tina-radius-small);\n      box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.12);\n\n      svg {\n        fill: var(--tina-color-grey-8);\n      }\n      ", " {\n        color: var(--tina-color-primary);\n      }\n\n      ", " {\n        svg:first-child {\n          opacity: 0;\n        }\n        svg:last-child {\n          opacity: 1;\n        }\n      }\n    "], ["\n      border-radius: var(--tina-radius-small);\n      box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.12);\n\n      svg {\n        fill: var(--tina-color-grey-8);\n      }\n      ", " {\n        color: var(--tina-color-primary);\n      }\n\n      ", " {\n        svg:first-child {\n          opacity: 0;\n        }\n        svg:last-child {\n          opacity: 1;\n        }\n      }\n    "]), qe, dt);
  }),
      ct = a.button.withConfig({
    displayName: "DeleteButton",
    componentId: "sc-xg3nc8"
  })(Ee = Ee || i(["\n  text-align: center;\n  flex: 0 0 auto;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  padding: 12px 8px;\n  margin: 0;\n  transition: all var(--tina-timing-short) ease-out;\n  &:hover {\n    background-color: var(--tina-color-grey-1);\n  }\n"], ["\n  text-align: center;\n  flex: 0 0 auto;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  padding: 12px 8px;\n  margin: 0;\n  transition: all var(--tina-timing-short) ease-out;\n  &:hover {\n    background-color: var(--tina-color-grey-1);\n  }\n"])),
      dt = a(function (n) {
    var e = f(n, []);
    return k.createElement("div", _I({}, e), k.createElement(u.DragIcon, null), k.createElement(u.ReorderIcon, null));
  }).withConfig({
    displayName: "DragHandle",
    componentId: "sc-1nik2oj"
  })(ke = ke || i(["\n  margin: 0;\n  flex: 0 0 auto;\n  width: 32px;\n  position: relative;\n  fill: inherit;\n  padding: 12px 0;\n  transition: all 85ms ease-out;\n  &:hover {\n    background-color: var(--tina-color-grey-1);\n    cursor: grab;\n  }\n  svg {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    width: 20px;\n    height: 20px;\n    transform: translate3d(-50%, -50%, 0);\n    transition: all var(--tina-timing-short) ease-out;\n  }\n  svg:last-child {\n    opacity: 0;\n  }\n  *:hover > & {\n    svg:first-child {\n      opacity: 0;\n    }\n    svg:last-child {\n      opacity: 1;\n    }\n  }\n"], ["\n  margin: 0;\n  flex: 0 0 auto;\n  width: 32px;\n  position: relative;\n  fill: inherit;\n  padding: 12px 0;\n  transition: all 85ms ease-out;\n  &:hover {\n    background-color: var(--tina-color-grey-1);\n    cursor: grab;\n  }\n  svg {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    width: 20px;\n    height: 20px;\n    transform: translate3d(-50%, -50%, 0);\n    transition: all var(--tina-timing-short) ease-out;\n  }\n  svg:last-child {\n    opacity: 0;\n  }\n  *:hover > & {\n    svg:first-child {\n      opacity: 0;\n    }\n    svg:last-child {\n      opacity: 1;\n    }\n  }\n"])),
      pt = function pt(n) {
    var e = n.setExpanded,
        t = n.isExpanded,
        r = n.tinaForm,
        a = n.field,
        i = n.index,
        o = n.label,
        l = n.template,
        s = k.useMemo(function () {
      return l.fields ? l.fields.map(function (n) {
        return _I(_I({}, n), {
          name: a.name + "." + i + "." + n.name
        });
      }) : [];
    }, [a.name, i, l.fields]);
    return k.createElement(_n, {
      isExpanded: t
    }, k.createElement(On, {
      onClick: function onClick() {
        return e(!1);
      }
    }, k.createElement(u.LeftArrowIcon, null), k.createElement(qe, null, o)), k.createElement(Wn, null, t ? k.createElement(c.FieldsBuilder, {
      form: r,
      fields: s
    }) : null));
  },
      ut = {
    name: "blocks",
    Component: function Component(n) {
      var a = n.tinaForm,
          r = n.form,
          i = n.field,
          e = n.input,
          o = k.useCallback(function (n, e) {
        var t = {};
        (t = "function" == typeof e.defaultItem ? e.defaultItem() : e.defaultItem || {})._template = n, r.mutators.insert(i.name, 0, t);
      }, [i.name, r.mutators]),
          t = e.value || [],
          l = k.useState(!1),
          s = l[0],
          c = l[1];
      return k.createElement(k.Fragment, null, k.createElement(Oe, null, k.createElement(We, null, k.createElement(qe, null, i.label || i.name), i.description && k.createElement(Gn, null, i.description)), k.createElement(p.IconButton, {
        onClick: function onClick() {
          return c(!0);
        },
        open: s,
        primary: !0,
        small: !0
      }, k.createElement(u.AddIcon, null)), k.createElement(tt, {
        open: s
      }, k.createElement(C.Dismissible, {
        click: !0,
        escape: !0,
        onDismiss: function onDismiss() {
          return c(!1);
        },
        disabled: !s
      }, k.createElement(rt, null, Object.entries(i.templates).map(function (n) {
        var e = n[0],
            t = n[1];
        return k.createElement(at, {
          key: e,
          onClick: function onClick() {
            o(e, t), c(!1);
          }
        }, t.label);
      }))))), k.createElement(ot, null, k.createElement(lt, null, k.createElement(g.Droppable, {
        droppableId: i.name,
        type: i.name
      }, function (n) {
        return k.createElement("div", {
          ref: n.innerRef,
          className: "edit-page--list-parent"
        }, 0 === t.length && k.createElement(Ze, null), t.map(function (n, e) {
          var t = i.templates[n._template];
          if (!t) return k.createElement(nt, {
            key: e,
            index: e,
            field: i,
            tinaForm: a
          });
          var r;
          return k.createElement($e, _I({
            key: e,
            block: n,
            template: t,
            index: e,
            field: i,
            tinaForm: a
          }, (r = n, t.itemProps ? t.itemProps(r) : {})));
        }), n.placeholder);
      }))));
    }
  },
      gt = Bn(function (n) {
    var e = n.input,
        t = n.field;
    return k.createElement(j, {
      colorFormat: t.colorFormat,
      userColors: t.colors,
      widget: t.widget,
      input: e
    });
  }),
      mt = {
    name: "color",
    Component: gt,
    parse: Un
  },
      ft = function ft() {
    return k.createElement(kt, null, "There are no items");
  },
      vt = function vt(n) {
    var t = n.tinaForm,
        e = n.field,
        r = n.index,
        a = (n.item, n.label, f(n, ["tinaForm", "field", "index", "item", "label"])),
        i = k.useCallback(function () {
      t.mutators.remove(e.name, r);
    }, [t, e, r]),
        o = [_I(_I({}, e.field), {
      label: "Value",
      name: e.name + "." + r
    })];
    return k.createElement(g.Draggable, {
      type: e.name,
      draggableId: e.name + "." + r,
      index: r
    }, function (n, e) {
      return k.createElement(k.Fragment, null, k.createElement(zt, _I({
        ref: n.innerRef,
        isDragging: e.isDragging
      }, n.draggableProps, n.dragHandleProps, a), k.createElement(ht, null, k.createElement(c.FieldsBuilder, {
        form: t,
        fields: o
      })), k.createElement(xt, null, k.createElement(Ft, null), k.createElement(It, {
        onClick: i
      }, k.createElement(u.TrashIcon, null)))));
    });
  },
      ht = a.div.withConfig({
    displayName: "ItemField",
    componentId: "sc-zyadiz"
  })(Ce = Ce || i(["\n  flex: 1 0 auto;\n  display: flex;\n  align-items: center;\n\n  label {\n    display: none;\n  }\n"], ["\n  flex: 1 0 auto;\n  display: flex;\n  align-items: center;\n\n  label {\n    display: none;\n  }\n"])),
      xt = a.div.withConfig({
    displayName: "ItemActions",
    componentId: "sc-r2pii6"
  })(ze = ze || i(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  max-height: 84px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  max-height: 84px;\n"])),
      bt = a.span.withConfig({
    displayName: "Label",
    componentId: "sc-qytg4f"
  })(Fe = Fe || i(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin: 0;\n  font-size: var(--tina-font-size-1);\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  line-height: 1.35;\n  flex: 1 1 auto;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: var(--tina-color-grey-8);\n  transition: all 85ms ease-out;\n  text-align: left;\n\n  ", ";\n"], ["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin: 0;\n  font-size: var(--tina-font-size-1);\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  line-height: 1.35;\n  flex: 1 1 auto;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: var(--tina-color-grey-8);\n  transition: all 85ms ease-out;\n  text-align: left;\n\n  ", ";\n"]), function (n) {
    return n.error && e.css(Ie = Ie || i(["\n      color: var(--tina-color-error) !important;\n    "], ["\n      color: var(--tina-color-error) !important;\n    "]));
  }),
      yt = a.div.withConfig({
    displayName: "ListHeader",
    componentId: "sc-1tp2d61"
  })(Be = Be || i(["\n  position: relative;\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n  ", " {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n"], ["\n  position: relative;\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 8px;\n  ", " {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n"]), Gn),
      wt = a.div.withConfig({
    displayName: "ListMeta",
    componentId: "sc-1vdyv4p"
  })(Ne = Ne || i(["\n  line-height: 1;\n"], ["\n  line-height: 1;\n"])),
      Et = a.div.withConfig({
    displayName: "ListPanel",
    componentId: "sc-172dthy"
  })(De = De || i(["\n  max-height: initial;\n  position: relative;\n  height: auto;\n  margin-bottom: 24px;\n  border-radius: var(--tina-radius-small);\n  background-color: var(--tina-color-grey-2);\n"], ["\n  max-height: initial;\n  position: relative;\n  height: auto;\n  margin-bottom: 24px;\n  border-radius: var(--tina-radius-small);\n  background-color: var(--tina-color-grey-2);\n"])),
      kt = a.div.withConfig({
    displayName: "EmptyList",
    componentId: "sc-zt3ep9"
  })(Pe = Pe || i(["\n  text-align: center;\n  border-radius: var(--tina-radius-small);\n  background-color: var(--tina-color-grey-2);\n  color: var(--tina-color-grey-4);\n  line-height: 1.35;\n  padding: 12px 0;\n  font-size: var(--tina-font-size-2);\n  font-weight: var(--tina-font-weight-regular);\n"], ["\n  text-align: center;\n  border-radius: var(--tina-radius-small);\n  background-color: var(--tina-color-grey-2);\n  color: var(--tina-color-grey-4);\n  line-height: 1.35;\n  padding: 12px 0;\n  font-size: var(--tina-font-size-2);\n  font-weight: var(--tina-font-weight-regular);\n"])),
      Ct = a.div.withConfig({
    displayName: "ItemList",
    componentId: "sc-1glca8r"
  })(je = je || i([""], [""])),
      zt = a.div.withConfig({
    displayName: "ListItem",
    componentId: "sc-med8jf"
  })(Ae = Ae || i(["\n  position: relative;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n  background-color: white;\n  border: 1px solid var(--tina-color-grey-2);\n  margin: 0 0 -1px 0;\n  overflow: visible;\n  line-height: 1.35;\n  padding: 0;\n  font-size: var(--tina-font-size-2);\n  font-weight: var(--tina-font-weight-regular);\n\n  ", " {\n    color: var(--tina-color-grey-8);\n    align-self: center;\n    max-width: 100%;\n  }\n\n  ", " {\n    padding: var(--tina-padding-small) calc(var(--tina-padding-small) / 2)\n      var(--tina-padding-small) var(--tina-padding-small);\n    display: flex;\n    align-items: center;\n  }\n\n  ", " {\n    margin: 0;\n    flex: 1 0 auto;\n  }\n\n  svg {\n    fill: var(--tina-color-grey-4);\n    transition: fill 85ms ease-out;\n  }\n\n  &:hover {\n    svg {\n      fill: var(--tina-color-grey-8);\n    }\n    ", " {\n      color: var(--tina-color-primary);\n    }\n  }\n\n  &:first-child {\n    border-radius: 4px 4px 0 0;\n  }\n\n  &:nth-last-child(2) {\n    border-radius: 0 0 4px 4px;\n    &:first-child {\n      border-radius: var(--tina-radius-small);\n    }\n  }\n\n  ", ";\n"], ["\n  position: relative;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n  background-color: white;\n  border: 1px solid var(--tina-color-grey-2);\n  margin: 0 0 -1px 0;\n  overflow: visible;\n  line-height: 1.35;\n  padding: 0;\n  font-size: var(--tina-font-size-2);\n  font-weight: var(--tina-font-weight-regular);\n\n  ", " {\n    color: var(--tina-color-grey-8);\n    align-self: center;\n    max-width: 100%;\n  }\n\n  ", " {\n    padding: var(--tina-padding-small) calc(var(--tina-padding-small) / 2)\n      var(--tina-padding-small) var(--tina-padding-small);\n    display: flex;\n    align-items: center;\n  }\n\n  ", " {\n    margin: 0;\n    flex: 1 0 auto;\n  }\n\n  svg {\n    fill: var(--tina-color-grey-4);\n    transition: fill 85ms ease-out;\n  }\n\n  &:hover {\n    svg {\n      fill: var(--tina-color-grey-8);\n    }\n    ", " {\n      color: var(--tina-color-primary);\n    }\n  }\n\n  &:first-child {\n    border-radius: 4px 4px 0 0;\n  }\n\n  &:nth-last-child(2) {\n    border-radius: 0 0 4px 4px;\n    &:first-child {\n      border-radius: var(--tina-radius-small);\n    }\n  }\n\n  ", ";\n"]), bt, c.FieldsGroup, Ln, bt, function (n) {
    return n.isDragging && e.css(Se = Se || i(["\n      border-radius: var(--tina-radius-small);\n      box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.12);\n\n      svg {\n        fill: var(--tina-color-grey-8);\n      }\n      ", " {\n        color: var(--tina-color-primary);\n      }\n\n      ", " {\n        svg:first-child {\n          opacity: 0;\n        }\n        svg:last-child {\n          opacity: 1;\n        }\n      }\n    "], ["\n      border-radius: var(--tina-radius-small);\n      box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.12);\n\n      svg {\n        fill: var(--tina-color-grey-8);\n      }\n      ", " {\n        color: var(--tina-color-primary);\n      }\n\n      ", " {\n        svg:first-child {\n          opacity: 0;\n        }\n        svg:last-child {\n          opacity: 1;\n        }\n      }\n    "]), bt, Ft);
  }),
      It = a.button.withConfig({
    displayName: "DeleteButton",
    componentId: "sc-jj4093"
  })(Le = Le || i(["\n  text-align: center;\n  flex: 1 0 auto;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  width: 38px;\n  height: 36px;\n  padding: 0 4px 5px 0;\n  margin: 0;\n  transition: all 85ms ease-out;\n  svg {\n    width: 24px;\n    height: 24px;\n    transition: all 85ms ease-out;\n  }\n  &:hover {\n    background-color: var(--tina-color-grey-1);\n  }\n"], ["\n  text-align: center;\n  flex: 1 0 auto;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  width: 38px;\n  height: 36px;\n  padding: 0 4px 5px 0;\n  margin: 0;\n  transition: all 85ms ease-out;\n  svg {\n    width: 24px;\n    height: 24px;\n    transition: all 85ms ease-out;\n  }\n  &:hover {\n    background-color: var(--tina-color-grey-1);\n  }\n"])),
      Ft = a(function (n) {
    var e = f(n, []);
    return k.createElement("div", _I({}, e), k.createElement(u.ReorderIcon, null));
  }).withConfig({
    displayName: "DragHandle",
    componentId: "sc-jecek"
  })(Te = Te || i(["\n  margin: 0;\n  flex: 1 0 auto;\n  width: 38px;\n  height: 36px;\n  padding: 5px 4px 0 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  fill: inherit;\n  transition: all 85ms ease-out;\n  &:hover {\n    background-color: var(--tina-color-grey-1);\n    cursor: grab;\n  }\n  svg {\n    width: 24px;\n    height: 24px;\n    transition: all 85ms ease-out;\n  }\n"], ["\n  margin: 0;\n  flex: 1 0 auto;\n  width: 38px;\n  height: 36px;\n  padding: 5px 4px 0 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  fill: inherit;\n  transition: all 85ms ease-out;\n  &:hover {\n    background-color: var(--tina-color-grey-1);\n    cursor: grab;\n  }\n  svg {\n    width: 24px;\n    height: 24px;\n    transition: all 85ms ease-out;\n  }\n"])),
      Bt = {
    name: "list",
    Component: function Component(n) {
      var t = n.tinaForm,
          e = n.form,
          r = n.field,
          a = n.input,
          i = k.useCallback(function () {
        var n = "";
        "function" == typeof r.defaultItem ? n = r.defaultItem() : void 0 !== r.defaultItem && (n = r.defaultItem), e.mutators.insert(r.name, 0, n);
      }, [e, r]),
          o = a.value || [],
          l = k.useCallback(function (n) {
        return r.itemProps ? r.itemProps(n) : {};
      }, [r.itemProps]);
      return k.createElement(k.Fragment, null, k.createElement(yt, null, k.createElement(wt, null, k.createElement(bt, null, r.label || r.name), r.description && k.createElement(Gn, null, r.description)), k.createElement(p.IconButton, {
        onClick: i,
        primary: !0,
        small: !0
      }, k.createElement(u.AddIcon, null))), k.createElement(Et, null, k.createElement(Ct, null, k.createElement(g.Droppable, {
        droppableId: r.name,
        type: r.name
      }, function (n) {
        return k.createElement("div", {
          ref: n.innerRef
        }, 0 === o.length && k.createElement(ft, null), o.map(function (n, e) {
          return k.createElement(vt, _I({
            key: e,
            tinaForm: t,
            field: r,
            item: n,
            index: e
          }, l(n)));
        }), n.placeholder);
      }))));
    }
  };

  function Nt(r, a, i, n) {
    var o = this,
        e = m.useCMS(),
        l = n || e.media.previewSrc,
        t = k.useState({
      src: "",
      loading: !0
    }),
        s = t[0],
        c = s.src,
        d = s.loading,
        p = t[1];
    return k.useEffect(function () {
      var e = !1,
          t = "";
      return v(o, void 0, void 0, function () {
        return h(this, function (n) {
          switch (n.label) {
            case 0:
              return n.trys.push([0, 2,, 3]), [4, l(r, a, i)];

            case 1:
              return t = n.sent(), [3, 3];

            case 2:
              return n.sent(), [3, 3];

            case 3:
              return e || p({
                src: t,
                loading: !1
              }), [2];
          }
        });
      }), function () {
        e = !0;
      };
    }, [r]), [c, d];
  }

  var Dt,
      Pt,
      jt,
      St = Bn(function (r) {
    var n,
        a = m.useCMS(),
        e = r.form,
        t = r.field,
        i = r.input,
        o = i.name,
        l = i.value,
        s = Nt(l, o, e.getState().values, t.previewSrc),
        c = s[0],
        d = s[1];

    function p(n) {
      n && (r.input.onChange(""), r.input.onChange(n));
    }

    r.field.clearable && (n = function n() {
      return p();
    });

    var u = r.field.uploadDir || function () {
      return "";
    };

    return k.createElement(dn, {
      value: l,
      previewSrc: c,
      loading: d,
      onClick: function onClick() {
        var n = u(r.form.getState().values);
        a.media.open({
          directory: n,
          onSelect: p
        });
      },
      onDrop: function onDrop(n) {
        var t = n[0];
        return v(void 0, void 0, void 0, function () {
          var e;
          return h(this, function (n) {
            switch (n.label) {
              case 0:
                return e = u(r.form.getState().values), [4, a.media.persist([{
                  directory: e,
                  file: t
                }])];

              case 1:
                return p(n.sent()[0]), [2];
            }
          });
        });
      },
      onClear: n
    });
  }),
      At = {
    name: "image",
    Component: St,
    parse: Un
  },
      Lt = Bn(function (n) {
    var e = n.input,
        t = n.field;
    return k.createElement(cn, _I({}, e, {
      step: t.step
    }));
  }),
      Tt = {
    name: "number",
    Component: Lt,
    parse: function parse(n) {
      return n && +n;
    }
  },
      Gt = Bn(A),
      Rt = {
    name: "select",
    type: "select",
    Component: Gt,
    parse: Un
  },
      Ht = Bn(function (n) {
    var e = n.input;
    return k.createElement(D, _I({}, e));
  }),
      Mt = {
    name: "textarea",
    Component: Ht,
    parse: Un
  },
      qt = Bn(function (n) {
    var e = n.input,
        t = n.field;
    return k.createElement(N, _I({}, e, {
      placeholder: t.placeholder
    }));
  }),
      Ot = {
    name: "text",
    Component: qt,
    validate: function validate(n, e, t, r) {
      if (r.required && !n) return "Required";
    },
    parse: Un
  },
      Wt = Bn(S),
      Vt = {
    name: "toggle",
    type: "checkbox",
    Component: Wt
  },
      _t = Bn(function (n) {
    var e = n.input,
        r = n.field,
        a = n.form,
        t = n.tinaForm,
        i = k.useState(""),
        o = i[0],
        l = i[1],
        s = k.useCallback(function (n) {
      var e, t;
      null !== (t = null === (e = a.getFieldState(r.name)) || void 0 === e ? void 0 : e.value) && void 0 !== t && t.includes(n) || n.length && (a.mutators.insert(r.name, 0, n), l(""));
    }, [a, r.name]),
        c = e.value || [];
    return k.createElement(k.Fragment, null, k.createElement(N, {
      value: o,
      onChange: function onChange(n) {
        return l(n.target.value);
      },
      placeholder: r.placeholder,
      onKeyPress: function onKeyPress(n) {
        " " !== n.key && "Enter" !== n.key || (n.preventDefault(), s(o));
      }
    }), k.createElement(Kt, null, c.map(function (n, e) {
      return k.createElement(Yt, {
        key: n,
        tinaForm: t,
        field: r,
        index: e
      }, n);
    })));
  }),
      Ut = a.button.withConfig({
    displayName: "DeleteButton",
    componentId: "sc-yt7wa"
  })(Dt = Dt || i(["\n  text-align: center;\n  flex: 0 0 auto;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  padding: 6px;\n  margin: 0 calc(var(--tina-padding-small) * -1) 0 6px;\n  display: flex;\n  align-items: center;\n  transition: all 85ms ease-out;\n\n  svg {\n    transition: all 85ms ease-out;\n    width: 16px;\n    height: auto;\n    fill: var(--tina-color-grey-8);\n  }\n  &:hover {\n    background-color: var(--tina-color-grey-1);\n  }\n"], ["\n  text-align: center;\n  flex: 0 0 auto;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  padding: 6px;\n  margin: 0 calc(var(--tina-padding-small) * -1) 0 6px;\n  display: flex;\n  align-items: center;\n  transition: all 85ms ease-out;\n\n  svg {\n    transition: all 85ms ease-out;\n    width: 16px;\n    height: auto;\n    fill: var(--tina-color-grey-8);\n  }\n  &:hover {\n    background-color: var(--tina-color-grey-1);\n  }\n"])),
      Kt = a.span.withConfig({
    displayName: "TagGrid",
    componentId: "sc-889c9u"
  })(Pt = Pt || i(["\n  display: flex;\n  flex-wrap: wrap;\n  margin: 4px -4px 0 -4px;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  margin: 4px -4px 0 -4px;\n"])),
      Yt = a(function (n) {
    var e = n.tinaForm,
        t = n.field,
        r = n.index,
        a = n.children,
        i = f(n, ["tinaForm", "field", "index", "children"]),
        o = k.useCallback(function () {
      e.mutators.remove(t.name, r);
    }, [e, t, r]);
    return k.createElement("span", _I({}, i), k.createElement("span", null, a), k.createElement(Ut, {
      onClick: o
    }, k.createElement(u.CloseIcon, null)));
  }).withConfig({
    displayName: "Tag",
    componentId: "sc-xhpuxb"
  })(jt = jt || i(["\n  border-radius: var(--tina-radius-small);\n  box-shadow: var(--tina-shadow-small);\n  background-color: var(--tina-color-grey-0);\n  border: 1px solid var(--tina-color-grey-2);\n  display: flex;\n  align-items: center;\n  font-size: var(--tina-font-size-2);\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  line-height: 1.35;\n  color: var(--tina-color-grey-8);\n  padding: 0 var(--tina-padding-small);\n  margin: 4px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n\n  span {\n    max-width: calc(var(--tina-sidebar-width) - 50px);\n    flex-shrink: 1;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n"], ["\n  border-radius: var(--tina-radius-small);\n  box-shadow: var(--tina-shadow-small);\n  background-color: var(--tina-color-grey-0);\n  border: 1px solid var(--tina-color-grey-2);\n  display: flex;\n  align-items: center;\n  font-size: var(--tina-font-size-2);\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  line-height: 1.35;\n  color: var(--tina-color-grey-8);\n  padding: 0 var(--tina-padding-small);\n  margin: 4px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n\n  span {\n    max-width: calc(var(--tina-sidebar-width) - 50px);\n    flex-shrink: 1;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n"])),
      Jt = {
    name: "tags",
    Component: _t,
    parse: Un
  };

  n.BaseTextField = N, n.BlocksFieldPlugin = ut, n.ColorField = gt, n.ColorFieldPlugin = mt, n.ColorPicker = j, n.Cover = X, n.FieldDescription = Gn, n.FieldLabel = Tn, n.FieldMeta = Nn, n.FieldWrapper = Ln, n.Group = Hn, n.GroupField = function (n) {
    return k.createElement("div", null, "Subfield: ", n.field.label || n.field.name);
  }, n.GroupFieldPlugin = Ge, n.GroupLabel = qe, n.GroupListFieldPlugin = Xe, n.GroupListHeader = Oe, n.GroupListMeta = We, n.GroupPanel = _n, n.ImageField = St, n.ImageFieldPlugin = At, n.ImageUpload = dn, n.Input = B, n.InputCss = E, n.ListFieldPlugin = Bt, n.NumberField = Lt, n.NumberFieldPlugin = Tt, n.NumberInput = cn, n.PanelBody = Wn, n.PanelHeader = On, n.Popover = Q, n.Select = A, n.SelectField = Gt, n.SelectFieldPlugin = Rt, n.Swatch = K, n.TagsField = _t, n.TagsFieldPlugin = Jt, n.TextArea = D, n.TextField = qt, n.TextFieldPlugin = Ot, n.TextareaField = Ht, n.TextareaFieldPlugin = Mt, n.Toggle = S, n.ToggleField = Wt, n.ToggleFieldPlugin = Vt, n.usePreviewSrc = Nt, n.wrapFieldsWithMeta = Bn, Object.defineProperty(n, "__esModule", {
    value: !0
  });
});